import { UserGroup } from "./userGroup";
import { User } from "./user";
import { UserGroupManagementDto } from "./userGroupManagementDto";

export class UserGroupManagement {
    userGroup: UserGroup;
    users: User[];

    constructor(dto: UserGroupManagementDto | null) {
        if(dto) {
            this.users = dto.users;
            this.userGroup = new UserGroup(dto.userGroup)
        }
    }
}